// 同人志指南 - 网站内容模拟数据
// 分类
export const categories = [
  {
    id: "yuri",
    name: "百合",
    en: "Yuri / GL",
    desc: "聚焦少女与少女之间的细腻情愫，从校园初见到大千世界相守，笔触温柔克制，余韵悠长。",
    count: 1260,
    hot: true,
    image: "https://readdy.ai/api/search-image?query=soft%20dreamy%20watercolor%20of%20two%20young%20women%20standing%20under%20falling%20cherry%20blossoms%2C%20pastel%20rose%20and%20cream%20tones%2C%20delicate%20lineart%2C%20romantic%20gentle%20mood%2C%20plain%20warm%20background%2C%20anime%20illustration&width=800&height=533&seq=cat-yuri&orientation=landscape",
  },
  {
    id: "bl",
    name: "耽美",
    en: "BL / Yaoi",
    desc: "描绘男性角色之间的情感与羁绊，风格多元，或炽烈或克制，是情感张力与人设深度的双重盛宴。",
    count: 1390,
    hot: true,
    image: "https://readdy.ai/api/search-image?query=atmospheric%20ink%20and%20wash%20illustration%20of%20two%20silhouetted%20men%20leaning%20close%20in%20a%20dim%20lantern%20lit%20room%2C%20warm%20coral%20and%20dark%20charcoal%20tones%2C%20emotional%20tension%2C%20minimal%20plain%20background%2C%20manga%20style&width=800&height=533&seq=cat-bl&orientation=landscape",
  },
  {
    id: "purelove",
    name: "纯爱",
    en: "Pure Romance",
    desc: "没有复杂设定与狗血冲突，只有恰到好处的温柔。日常琐碎里的心动，最适合忙里偷闲治愈心情。",
    count: 980,
    hot: false,
    image: "https://readdy.ai/api/search-image?query=gentle%20sunlit%20watercolor%20of%20a%20couple%20sharing%20an%20umbrella%20on%20a%20rainy%20street%2C%20soft%20warm%20yellow%20and%20cream%20palette%2C%20cozy%20peaceful%20atmosphere%2C%20plain%20soft%20background%2C%20anime%20illustration&width=800&height=533&seq=cat-purelove&orientation=landscape",
  },
  {
    id: "hotblood",
    name: "热血",
    en: "Action & Adventure",
    desc: "少年意气与伙伴情谊，战斗场面张力十足，分镜凌厉。友情、成长与永不放弃的热血燃向之作。",
    count: 850,
    hot: true,
    image: "https://readdy.ai/api/search-image?query=dynamic%20illustration%20of%20anime%20characters%20in%20mid%20action%20pose%20with%20energy%20bursts%2C%20vibrant%20warm%20orange%20and%20coral%20tones%2C%20powerful%20motion%20lines%2C%20clean%20background%2C%20comic%20art&width=800&height=533&seq=cat-hotblood&orientation=landscape",
  },
  {
    id: "xianxia",
    name: "仙侠",
    en: "Xianxia & Fantasy",
    desc: "御剑乘风、山河万象，融古风美学与神话幻想于一体。从凡尘少年到问道巅峰，写尽东方想象之美。",
    count: 720,
    hot: false,
    image: "https://readdy.ai/api/search-image?query=ethereal%20ink%20painting%20of%20a%20sword%20immortal%20flying%20above%20misty%20mountain%20peaks%20with%20cranes%2C%20warm%20gold%20and%20amber%20with%20deep%20charcoal%2C%20chinese%20fantasy%20aesthetic%2C%20plain%20sky%20background&width=800&height=533&seq=cat-xianxia&orientation=landscape",
  },
  {
    id: "campus",
    name: "校园",
    en: "School Life",
    desc: "教室、天台与放学后的街道，青涩懵懂的情感和并肩前行的约定。属于学生时代独有的清新悸动。",
    count: 1010,
    hot: true,
    image: "https://readdy.ai/api/search-image?query=bright%20afternoon%20illustration%20of%20high%20school%20students%20on%20a%20sunlit%20school%20rooftop%2C%20pastel%20warm%20tones%2C%20youthful%20fresh%20mood%2C%20blue%20sky%20minimal%20background%2C%20slice%20of%20life%20anime&width=800&height=533&seq=cat-campus&orientation=landscape",
  },
  {
    id: "mystery",
    name: "悬疑",
    en: "Mystery & Thriller",
    desc: "反转不断、气氛阴翳，真相隐藏在蛛丝马迹之间。烧脑的设定与人物宿命交织，越读越欲罢不能。",
    count: 610,
    hot: false,
    image: "https://readdy.ai/api/search-image?query=noir%20style%20illustration%20of%20a%20silhouetted%20detective%20under%20a%20single%20street%20lamp%20in%20fog%2C%20deep%20charcoal%20and%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20minimal%20dark%20background%2C%20comic%20art&width=800&height=533&seq=cat-mystery&orientation=landscape",
  },
  {
    id: "scifi",
    name: "科幻",
    en: "Sci-Fi & Mecha",
    desc: "星海征途与钢铁机甲，人工智能与人类的边界。世界观宏大，探讨存在、自由与未来的浪漫。",
    count: 540,
    hot: false,
    image: "https://readdy.ai/api/search-image?query=futuristic%20illustration%20of%20a%20mecha%20silhouette%20against%20a%20glowing%20nebula%20and%20starry%20sky%2C%20warm%20amber%20and%20deep%20charcoal%20palette%2C%20epic%20scale%2C%20clean%20background%2C%20sci%20fi%20concept%20art&width=800&height=533&seq=cat-scifi&orientation=landscape",
  },
];

// 热门同人志榜单
export const popularWorks = [
  {
    id: "work-1",
    rank: 1,
    title: "雨后长廊",
    author: "白鹭",
    pairing: "叶青 × 沈舟",
    category: "校园青春",
    tag: "青梅竹马",
    rating: 9.6,
    series: 3,
    synopsis: "一场突如其来的大雨，将两条本不相交的人生轨迹牵到了一起。天台漏水、同一把伞、错过的末班车，青春的答案藏在每一次欲言又止里。",
    image: "https://readdy.ai/api/search-image?query=soft%20watercolor%20book%20cover%20of%20two%20school%20students%20sharing%20an%20umbrella%20under%20rain%2C%20warm%20coral%20and%20cream%20tones%2C%20nostalgic%20youth%20mood%2C%20clean%20minimal%20composition%2C%20romance%20manga%20art&width=600&height=800&seq=work-1&orientation=portrait",
  },
  {
    id: "work-2",
    rank: 2,
    title: "双子星罗盘",
    author: "织火",
    pairing: "凌澈 × 陆遥",
    category: "科幻机甲",
    tag: "星际公路",
    rating: 9.4,
    series: 5,
    synopsis: "编号失序的星际快递员，在报废星舰上捡到一台会说话的旧式导航仪。一人一机穿越星海，拼凑出被抹去的记忆与整片银河的真相。",
    image: "https://readdy.ai/api/search-image?query=stylized%20book%20cover%20of%20a%20lonely%20pilot%20inside%20a%20worn%20spaceship%20cockpit%20viewing%20a%20glowing%20nebula%2C%20amber%20and%20deep%20charcoal%20tones%2C%20epic%20quiet%20mood%2C%20clean%20composition%2C%20sci%20fi%20manga%20cover&width=600&height=800&seq=work-2&orientation=portrait",
  },
  {
    id: "work-3",
    rank: 3,
    title: "山鬼谣",
    author: "南柯",
    pairing: "白泽 × 苍梧",
    category: "奇幻仙侠",
    tag: "妖怪志",
    rating: 9.3,
    series: 4,
    synopsis: "山鬼自幽谷中来，为寻一桩百年前的旧怨踏入人间。灯火阑珊处与少年捕快相遇，一人想收妖，一人想回家。",
    image: "https://readdy.ai/api/search-image?query=ethereal%20ink%20book%20cover%20of%20a%20mountain%20spirit%20in%20flowing%20robes%20among%20glowing%20lanterns%20in%20an%20ancient%20town%2C%20warm%20gold%20and%20charcoal%2C%20chinese%20fantasy%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=work-3&orientation=portrait",
  },
  {
    id: "work-4",
    rank: 4,
    title: "盛夏的潮汐",
    author: "三鱼",
    pairing: "许望 × 江晚",
    category: "纯爱治愈",
    tag: "海边小镇",
    rating: 9.2,
    series: 2,
    synopsis: "回到外婆海边小镇的少年，遇见沉默经营灯塔咖啡店的青年。潮汐来去，两个带着伤痕的人，慢慢学会不再逃避。",
    image: "https://readdy.ai/api/search-image?query=gentle%20illustrated%20book%20cover%20of%20a%20lighthouse%20and%20seaside%20town%20at%20dusk%2C%20warm%20sunset%20orange%20and%20cream%20tones%2C%20healing%20peaceful%20mood%2C%20clean%20minimal%20composition%2C%20manga%20cover&width=600&height=800&seq=work-4&orientation=portrait",
  },
  {
    id: "work-5",
    rank: 5,
    title: "白夜行灯",
    author: "应雀",
    pairing: "裴烬 × 顾生",
    category: "悬疑烧脑",
    tag: "民国探案",
    rating: 9.1,
    series: 3,
    synopsis: "巡捕房档案里一桩桩无头悬案，将警探与江湖画师卷入同一场阴谋。白夜之下，明灯所指的究竟是真相，还是深渊。",
    image: "https://readdy.ai/api/search-image?query=noir%20book%20cover%20of%20a%20detective%20and%20artist%20in%20old%20shanghai%20lantern%20alley%20at%20night%2C%20deep%20charcoal%20amber%20and%20crimson%20tones%2C%20suspenseful%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=work-5&orientation=portrait",
  },
  {
    id: "work-6",
    rank: 6,
    title: "少年剑与风筝",
    author: "禾野",
    pairing: "阿莱 × 赵小满",
    category: "热血冒险",
    tag: "少年漫",
    rating: 9.0,
    series: 6,
    synopsis: "小镇少年捡到一把会说话的断剑，从此踏上讨伐山海巨兽的旅程。伙伴、梦想与绝不低头的热血，一路向北。",
    image: "https://readdy.ai/api/search-image?query=vibrant%20book%20cover%20of%20a%20brave%20boy%20holding%20a%20glowing%20sword%20and%20a%20kite%20against%20clouds%2C%20warm%20orange%20coral%20and%20gold%20tones%2C%20adventurous%20energetic%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=work-6&orientation=portrait",
  },
  {
    id: "work-7",
    rank: 7,
    title: "花房来信",
    author: "半糖",
    pairing: "温然 × 苏黎",
    category: "百合同志",
    tag: "书信体",
    rating: 8.9,
    series: 2,
    synopsis: "花园主理人与常来买花的女孩，从一纸匿名手写信开始，慢慢打开彼此尘封的心。温柔缱绻，如四月的花香。",
    image: "https://readdy.ai/api/search-image?query=soft%20book%20cover%20of%20a%20flower%20shop%20and%20love%20letters%20scattered%20on%20a%20wooden%20table%2C%20pastel%20rose%20and%20cream%20tones%2C%20tender%20romantic%20mood%2C%20clean%20minimal%20composition%2C%20manga%20cover&width=600&height=800&seq=work-7&orientation=portrait",
  },
  {
    id: "work-8",
    rank: 8,
    title: "长安未眠",
    author: "解语花",
    pairing: "李重言 × 顾昭",
    category: "耽美同人",
    tag: "宫廷权谋",
    rating: 8.8,
    series: 4,
    synopsis: "朝堂诡谲，武将世家之子与病弱太子在长安夜色中结下盟约。权谋步步惊心，唯有并肩之人值得托付性命。",
    image: "https://readdy.ai/api/search-image?query=grand%20book%20cover%20of%20a%20general%20and%20a%20prince%20beneath%20a%20glowing%20moon%20over%20ancient%20changan%20rooftops%2C%20warm%20gold%20crimson%20and%20charcoal%2C%20dramatic%20court%20intrigue%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=work-8&orientation=portrait",
  },
];

// 冷门佳作
export const gemWorks = [
  {
    id: "gem-1",
    title: "候鸟航线",
    author: "白藏",
    pairing: "祝遥 × 简一",
    category: "百合同志",
    reason: "画风如散文诗，候鸟迁徙隐喻情感聚散，结尾余韵极长，被低估的安静神作。",
    image: "https://readdy.ai/api/search-image?query=poetic%20book%20cover%20of%20migrating%20birds%20over%20a%20winding%20coastline%20at%20sunrise%2C%20soft%20warm%20peach%20and%20cream%20tones%2C%20minimal%20elegant%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-1&orientation=portrait",
  },
  {
    id: "gem-2",
    title: "纸上迷城",
    author: "陆止",
    pairing: "景行 × 沈聿",
    category: "悬疑烧脑",
    reason: "将建筑图纸与推理结合的天才设定，节奏克制信息量大，值得反复回味的冷门烧脑作。",
    image: "https://readdy.ai/api/search-image?query=intricate%20book%20cover%20of%20an%20architectural%20blueprint%20unfolding%20into%20a%20maze%20of%20lines%20and%20shadow%2C%20charcoal%20amber%20tones%2C%20mysterious%20intellectual%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-2&orientation=portrait",
  },
  {
    id: "gem-3",
    title: "泥泞里的歌",
    author: "阿澄",
    pairing: "陈野 × 老周",
    category: "日常搞笑",
    reason: "小城修理铺的市井烟火气，笑中带泪的群像描摹，无人在意的角落藏着最暖的人情。",
    image: "https://readdy.ai/api/search-image?query=heartfelt%20book%20cover%20of%20a%20cozy%20small%20town%20repair%20shop%20with%20characters%20laughing%20at%20golden%20dusk%2C%20warm%20amber%20and%20cream%20tones%2C%20slice%20of%20life%20humor%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-3&orientation=portrait",
  },
  {
    id: "gem-4",
    title: "退潮日",
    author: "江辞",
    pairing: "林霜 × 迟回",
    category: "纯爱治愈",
    reason: "关于失去与告别的温柔故事，留白克制，最后一页的潮水让无数人落泪。",
    image: "https://readdy.ai/api/search-image?query=melancholic%20book%20cover%20of%20a%20person%20watching%20the%20receding%20tide%20alone%20on%20a%20wide%20beach%2C%20soft%20warm%20grey%20and%20peach%20tones%2C%20quiet%20introspective%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-4&orientation=portrait",
  },
  {
    id: "gem-5",
    title: "雾中来客",
    author: "晏无",
    pairing: "顾言 × 鹤九",
    category: "奇幻仙侠",
    reason: "雾隐山城的妖怪奇谭，民俗考据扎实，美术古拙厚重，小众但完成度极高。",
    image: "https://readdy.ai/api/search-image?query=misty%20book%20cover%20of%20an%20ancient%20mountain%20town%20shrouded%20in%20fog%20with%20a%20spirit%20figure%20and%20lanterns%2C%20warm%20gold%20and%20deep%20charcoal%2C%20folk%20fantasy%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-5&orientation=portrait",
  },
  {
    id: "gem-6",
    title: "停机坪",
    author: "柯北",
    pairing: "时砚 × 秦渊",
    category: "科幻机甲",
    reason: "以地面技师视角写机甲战争，反战主题与机设细节双在线，被埋没的硬核科幻。",
    image: "https://readdy.ai/api/search-image?query=industrial%20book%20cover%20of%20a%20ground%20technician%20silhouetted%20before%20a%20giant%20docked%20mecha%20at%20dusk%2C%20amber%20and%20charcoal%20tones%2C%20grim%20realistic%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-6&orientation=portrait",
  },
  {
    id: "gem-7",
    title: "晚风书店",
    author: "苏禾",
    pairing: "闻溪 × 夏木",
    category: "校园青春",
    reason: "发生在毕业季前最后一学期，书店里的每一次偶遇都恰到好处，青涩又动人。",
    image: "https://readdy.ai/api/search-image?query=nostalgic%20book%20cover%20of%20two%20students%20among%20bookshelves%20in%20a%20warm%20lit%20bookstore%20at%20dusk%2C%20warm%20coral%20and%20cream%20tones%2C%20gentle%20youthful%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-7&orientation=portrait",
  },
  {
    id: "gem-8",
    title: "白头翁",
    author: "齐眉",
    pairing: "祖父 × 旧友",
    category: "历史同人",
    reason: "以两位老友一生书信串起半个世纪风雨，克制宏大，是冷门分类里的宝藏。",
    image: "https://readdy.ai/api/search-image?query=aged%20book%20cover%20of%20stacked%20old%20letters%20and%20a%20fountain%20pen%20on%20a%20wooden%20desk%20beside%20a%20window%2C%20warm%20sepia%20and%20cream%20tones%2C%20melancholic%20timeless%20mood%2C%20clean%20composition%2C%20manga%20cover&width=600&height=800&seq=gem-8&orientation=portrait",
  },
];

// 常见问题
export const faqs = [
  {
    q: "什么是同人志？",
    a: "同人志是创作者基于既有作品（漫画、动画、游戏等）的设定与角色进行的二次创作漫画，也可包含纯原创内容。它不以商业盈利为首要目的，更多是爱好者表达热爱、交流创意的载体。",
  },
  {
    q: "百合与耽美同人志有什么区别？",
    a: "百合同人志（GL）以女性角色之间的情感为主线，耽美同人志（BL）则以男性角色之间的情感为主线。两者都强调细腻的情感与人物关系的刻画，是当下同人创作中热度极高的两大分支。",
  },
  {
    q: "如何快速找到自己喜欢风格的同人志？",
    a: "建议先通过本站的「同人志分类」明确题材方向（如纯爱、热血、悬疑），再结合「CP配对推荐」寻找心仪的人物关系，最后参考「热门榜单」与「冷门佳作」两类内容挑选具体作品，效率最高。",
  },
  {
    q: "CP配对推荐是什么？",
    a: "CP是 Couple 的缩写，指粉丝心中存在情感联结的一对角色。配对推荐会基于作品风格、人物性格契合度与叙事张力，为读者筛选出值得一读的组合，帮助降低选书试错成本。",
  },
  {
    q: "热门榜单与冷门佳作的区别是什么？",
    a: "热门榜单收录关注度高、讨论量大、流传度广的作品，适合快速入门；冷门佳作则聚焦完成度高但尚未被广泛发现的宝藏作品，适合想探索惊喜、拓宽阅读边界的同好。",
  },
  {
    q: "本站内容更新频率如何？",
    a: "我们会定期跟进新作首发与社区口碑变化，持续优化分类、榜单与配对推荐。你可以在「关于我们」页面订阅内容更新提醒，第一时间获取最新盘点。",
  },
];